import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Container, Button, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { CSVLink } from 'react-csv';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';

const EmployeeManage = () => {
    const [companies, setCompanies] = useState([]);
    const [isList, setIsList] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [employeesDownload, setEmployeesDownload] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [roles, setRoles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(localStorage.getItem('companyID'));
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(8);
    const [isEdit, setIsEdit] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [formData, setFormData] = useState({
        email: '',
        firstName: '',
        lastName: '',
        department: '',
        phoneNumber: '',
        country: '',
        city: '',
        designation: '',
        role: '',
        company: localStorage.getItem('companyID'),
        userID: localStorage.getItem('userId'), // Assuming you have the userID
    });
    // Define state to hold selected student IDs
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const handleSelectAllChange = (selectAll) => {
        if (selectAll) {
            setSelectedEmployees([]);
        } else {
            const allEmployeeIds = employees.map(employee => employee._id);
            console.log(allEmployeeIds);
            setSelectedEmployees(allEmployeeIds);
        }
        setSelectAll(!selectAll);
    };

    // Function to handle checkbox change
    const handleCheckboxChange = (employeeId) => {
        // Check if the employeeId is already selected
        const selectedIndex = selectedEmployees.indexOf(employeeId);

        if (selectedIndex === -1) {
            // If not selected, add it to the array
            setSelectedEmployees([...selectedEmployees, employeeId]);
        } else {
            // If already selected, remove it from the array
            const updatedSelection = [
                ...selectedEmployees.slice(0, selectedIndex),
                ...selectedEmployees.slice(selectedIndex + 1)
            ];
            setSelectedEmployees(updatedSelection);
        }
    };

    const handleRemoveSelected = async (event) => {
        event.preventDefault();
        try {
            if (selectedEmployees.length > 0) {
                const isConfirmed = window.confirm("Are you sure you want to modify these students?");

                if (!isConfirmed) return; // If user cancels, do nothing
                const token = localStorage.getItem('token');
                const requestOptions = {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json', 'Authorization': token },
                };

                for (const employeeId of selectedEmployees) {
                    const response = await fetch(`https://beiguru.co.in/employee/${employeeId}`, requestOptions);

                    if (response.ok) {
                        console.log(`Students ${employeeId} modify successfully`);
                    } else {
                        console.error(`Failed to modify employee ${employeeId}`);
                    }
                }

                // After deleting all selected employees, you might want to refresh the student list
                fetchEmployees(); // Assuming you have fetchEmployees function defined
                setSelectedEmployees([]); // Clear selected employees array
                alert('Students modify successfully');
            } else {
                alert('No student was selected!');
            }
        } catch (error) {
            console.error('Error modify students:', error);
        }
    };


    useEffect(() => {
        fetchRoles();
        fetchDepartments();
        fetchDesignations();
    }, []);

    useEffect(() => {
        fetchEmployees();
    }, [itemsPerPage, currentPage, selectedCompany, selectedDepartment, searchQuery]); // Add formData.company to the dependencies

    const [sortedField, setSortedField] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');

    const handleSort = (field) => {
        if (sortedField === field) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortedField(field);
            setSortOrder('asc');
        }
    };

    const sortedEmployees = [...employees].sort((a, b) => {
        if (sortedField) {
            const aValue = a[sortedField];
            const bValue = b[sortedField];

            if (sortOrder === 'asc') {
                return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
            } else {
                return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
            }
        } else {
            return 0;
        }
    });


    const fetchRoles = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/role", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setRoles(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchDepartments = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/department", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setDepartments(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchDesignations = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/designation", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => setDesignations(result))
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const fetchEmployees = async () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        let apiUrl = `https://beiguru.co.in/admin/employees?page=${currentPage}&limit=${itemsPerPage}`;
        if (selectedCompany) {
            apiUrl += `&companyId=${selectedCompany}`; // Append company ID if selected
        }
        if (selectedDepartment) {
            apiUrl += `&departmentId=${selectedDepartment}`; // Append department ID if selected
        }
        if (searchQuery) {
            apiUrl += `&search=${searchQuery}`; // Append search query
        }
        fetch(apiUrl, requestOptions)
            .then((response) => {
                if (response.status === 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json();
                }
            })
            .then((result) => {
                setEmployees(result.employees);
                setTotalPages(result.totalPages);
                setCurrentPage(result.currentPage);
            })
            .catch((error) => console.error(error));
        let apiUrl2 = `https://beiguru.co.in/admin/employees?page=1&limit=10000`;
        if (selectedCompany) {
            apiUrl2 += `&companyId=${selectedCompany}`;
        }
        if (selectedDepartment) {
            apiUrl2 += `&departmentId=${selectedDepartment}`;
        }
        if (searchQuery) {
            apiUrl2 += `&search=${searchQuery}`;
        }
        fetch(apiUrl2, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch employee data');
                }
                return response.json();
            })
            .then((result) => {
                setEmployeesDownload(result.employees);
            })
            .catch((error) => {
                console.error(error);
            });
    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const companyResponse = await fetch('https://beiguru.co.in/admin/register-employee', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token') // Replace with your JWT token
                },
                body: JSON.stringify({
                    email: formData.email,
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    department: formData.department,
                    phoneNumber: formData.phoneNumber,
                    country: formData.country,
                    city: formData.city,
                    designation: formData.designation,
                    role: formData.role,
                    company: formData.company,
                    userID: localStorage.getItem('userId'), // Assuming you have the userID
                })
            });

            if (!companyResponse.ok) {
                throw new Error('Failed to add employee');
            }

            const companyData = await companyResponse.json();

            setFormData({
                email: '',
                firstName: '',
                lastName: '',
                department: '',
                phoneNumber: '',
                country: '',
                city: '',
                designation: '',
                role: '',
                company: localStorage.getItem('companyID'),
                userID: localStorage.getItem('userId'), // Assuming you have the userID
            });
            alert('Students created successfully');
            await fetchEmployees();
            setIsLoading(false);
            setIsList(true);
        } catch (error) {
            alert('There was a error creating student, please try again.');
            setIsLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleDelete = async (employeeId) => {
        // Display confirmation popup before deleting
        const isConfirmed = window.confirm("Are you sure you want to modify this student?");

        if (!isConfirmed) return; // If user cancels, do nothing

        try {
            const token = localStorage.getItem('token'); // Get the authentication token
            const requestOptions = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': token },
            };

            const response = await fetch(`https://beiguru.co.in/employee/${employeeId}`, requestOptions);

            if (response.ok) {
                alert('Students modify successfully');
                fetchEmployees();
            } else {
                throw new Error('Failed to modify employee');
            }
        } catch (error) {
            console.error('Error modify employee:', error);
            alert('Failed to modify student');
        }
    };

    const handleEdit = (course) => {
        setFormData({
            employeeID: course._id,
            email: course.email,
            firstName: course.firstName,
            lastName: course.lastName,
            department: course.department ? course.department._id : '',
            phoneNumber: course.phoneNumber,
            country: course.country,
            city: course.city,
            designation: course.designation,
            role: course.role,
            company: course.company._id,
            userID: localStorage.getItem('userId'), // Assuming you have the userID
        });
        setIsEdit(true);
        setIsList(false);
    };


    const handleModify = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const companyResponse = await fetch(`https://beiguru.co.in/admin/employee/${formData.employeeID}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('token') // Replace with your JWT token
                },
                body: JSON.stringify({
                    email: formData.email,
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    department: formData.department,
                    phoneNumber: formData.phoneNumber,
                    country: formData.country,
                    city: formData.city,
                    designation: formData.designation,
                    role: formData.role,
                    company: formData.company,
                    userID: localStorage.getItem('userId'), // Assuming you have the userID
                })
            });
            if (!companyResponse.ok) {
                throw new Error('Failed to add company');
            }
            setFormData({
                email: '',
                firstName: '',
                lastName: '',
                department: '',
                phoneNumber: '',
                country: '',
                city: '',
                designation: '',
                role: '',
                company: localStorage.getItem('companyID'),
                userID: localStorage.getItem('userId'), // Assuming you have the userID
            });
            alert('Students modified successfully');
            await fetchEmployees();
            setIsLoading(false);
            setIsEdit(false);
            setIsList(true);
        } catch (error) {
            alert('There was a error modifying student, please try again.');
            setIsLoading(false);
        }
    };

    return <Grid item xs={10} style={{ padding: '20px', height: '100%', fontFamily: "Noto Sans", fontWeight: '500', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Container fluid style={{ height: '100%', }}>
            <div style={{ marginBottom: '15px', justifyContent: 'space-between', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'row' }}>
                {isList ? (
                    <div style={{ display: 'flex', width: '30%', flexDirection: 'row', justifyContent: 'start', alignItems: 'start' }}>
                        <Form.Group controlId="formCompanyFilter" style={{ flex: 1 }}>
                            <Form.Control
                                className="w-100"
                                style={{ borderRadius: '10px' }}
                                as="select"
                                value={selectedDepartment}
                                onChange={(e) => {
                                    setSelectedDepartment(e.target.value);
                                    setCurrentPage(1);
                                }}>
                                <option value="">All Department</option>
                                {departments.map(department => (
                                    <option key={department._id} value={department._id}>{department.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </div>
                ) : (
                    <h4>{isEdit ? 'Edit' : 'Create'} Students</h4>
                )}

                {!isEdit && isList && (
                    <>
                        <Form.Control
                            style={{ borderRadius: '10px', marginRight: '10px', flex: 1, marginLeft: '10px' }}
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <Button
                            style={{ marginRight: '5px', fontWeight: '600', borderRadius: '20px', backgroundColor: 'green', borderColor: 'green' }}
                            elevation={3}
                            variant="primary"
                            type="button"
                            onClick={() => {
                                document.getElementById('csvUpload').click();
                            }}>
                            Upload
                        </Button>
                        <Button
                            style={{ marginRight: '5px', fontWeight: '600', borderRadius: '20px', backgroundColor: 'red', borderColor: 'red' }}
                            elevation={3}
                            variant="primary"
                            type="button"
                            onClick={() => {
                                const csvContent = "email,firstName,lastName,company\ntheprasunranjan@gmail.com,John,Doe,661cfd33d8cb6bf135309168\ntheinolas@gmail.com,Jane,Smith,661cfd33d8cb6bf135309168";
                                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                                const link = document.createElement('a');
                                const url = URL.createObjectURL(blob);
                                link.setAttribute('href', url);
                                link.setAttribute('download', 'sample.csv');
                                link.style.visibility = 'hidden';
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }}>
                            Sample CSV
                        </Button>
                        {/* <Button
                            variant="outline-primary"
                            style={{ marginRight: '5px', fontWeight: '600', borderRadius: '20px' }}
                            elevation={3}>
                            <CSVLink
                                data={employeesDownload.map((employee, index) => ({
                                    "First Name": employee.firstName,
                                    "Last Name": employee.lastName,
                                    "Department": employee.department ? employee.department.name : 'N/A',
                                    "Email": employee.email,
                                    "Phone": employee.phone,
                                    "School": employee.company.name,
                                    "Country": employee.country,
                                    "City": employee.city,
                                }))}
                                filename={"data.csv"}
                                target="_blank">
                                Download
                            </CSVLink>
                        </Button> */}
                        <Button
                            style={{ fontWeight: '600', borderRadius: '20px', backgroundColor: 'red', borderColor: 'red', marginRight: '5px', }}
                            elevation={3}
                            variant="primary"
                            type="button"
                            disabled={isLoading}
                            onClick={handleRemoveSelected}>
                            Toggle Status
                        </Button>
                    </>
                )}

                <Button
                    style={{ fontWeight: '600', borderRadius: '20px' }}
                    elevation={3}
                    className="w-10"
                    variant="primary"
                    type="submit"
                    disabled={isLoading}
                    onClick={(event) => {
                        event.preventDefault();
                        setIsList(!isList);
                        setIsEdit(false);
                        setFormData({
                            email: '',
                            firstName: '',
                            lastName: '',
                            department: '',
                            phoneNumber: '',
                            country: '',
                            city: '',
                            designation: '',
                            role: '',
                            company: localStorage.getItem('companyID'),
                            userID: localStorage.getItem('userId'),
                        });
                    }}>
                    {isList ? 'Create' : 'Cancel'}
                </Button>
            </div>
            <input
                id="csvUpload"
                type="file"
                style={{ display: 'none' }}
                accept=".csv"
                onChange={async (event) => {
                    const file = event.target.files[0];
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", localStorage.getItem('token'));
                    const formdata = new FormData();
                    formdata.append("csvFile", file, "test.csv");
                    formdata.append("userID", localStorage.getItem('userId'));

                    const requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        body: formdata,
                        redirect: "follow"
                    };

                    await fetch("https://beiguru.co.in/admin/register-employees-from-csv", requestOptions)
                        .then((response) => response.json())
                        .then((result) => alert(result.message))
                        .catch((error) => console.error(error));
                    fetchEmployees();
                }}
            />
            <Row>
                {isList ? <Col xs={12} style={{ overflowY: 'scroll', flex: 1, width: '100%', height: '83vh', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ width: '100%' }}>
                        {employees.length > 0 ? (
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                checked={selectAll}
                                                onChange={() => handleSelectAllChange(selectAll)}
                                            />
                                        </th>
                                        <th onClick={() => handleSort('firstName')}>Name</th>
                                        <th onClick={() => handleSort('lastName')}>Last Login</th>
                                        <th onClick={() => handleSort('department.name')}>Department</th>
                                        <th onClick={() => handleSort('email')}>Email</th>
                                        <th onClick={() => handleSort('company.name')}>School</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedEmployees.map((employee, index) => (
                                        <tr key={employee._id}>
                                            <td style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly' }}><div style={{
                                                backgroundColor: employee.active ? 'green' : 'red',
                                                width: '10px',
                                                height: '50px'
                                            }} /><input style={{ margin: '0px', padding: '0px' }} checked={selectedEmployees.includes(employee._id)} type="checkbox" onChange={() => handleCheckboxChange(employee._id)} /></td>
                                            <td>{employee.firstName} {employee.lastName}</td>
                                            <td>{new Date(employee.logintime).toLocaleString()}<p style={{ margin: '0px', padding: '0px', fontSize: '10px' }}>{employee.ip}</p></td>
                                            <td>{employee.department ? employee.department.name : 'N/A'}</td>
                                            <td>
                                                {employee.email}
                                                <p style={{ margin: '0px', padding: '0px', fontSize: '10px' }}>{employee._id}</p>
                                            </td>
                                            <td>{employee.company.name}</td>
                                            <td>
                                                <EditNoteIcon
                                                    onClick={() => handleEdit(employee)}
                                                    style={{ color: 'blue', cursor: 'pointer' }}
                                                />
                                                <DoDisturbIcon
                                                    onClick={() => handleDelete(employee._id)}
                                                    style={{ color: 'blue', cursor: 'pointer' }}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        ) : (
                            <div style={{ margin: '20px', textAlign: 'center' }}>No students found, please try again!</div>
                        )}
                    </div>
                    <div style={{ flex: 1 }} />
                    {employees.length > 0 ? <nav aria-label="Courses pagination">
                        <ul className="pagination" style={{ display: 'flex', alignItems: 'center' }}>
                            <li className="page-item">
                                <select
                                    className="form-select form-select-sm"
                                    aria-label="Default select example"
                                    value={itemsPerPage}
                                    onChange={(e) => {
                                        setCurrentPage(1);
                                        setItemsPerPage(parseInt(e.target.value));
                                    }}
                                    style={{ height: '40px' }} // Set the height to 100%
                                >
                                    <option value="8">8 per page</option>
                                    <option value="15">15 per page</option>
                                    <option value="50">50 per page</option>
                                    <option value="100">100 per page</option>
                                </select>
                            </li>
                            <div style={{ width: '10px' }} />
                            {[...Array(totalPages).keys()].map((page) => (
                                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                                        {page + 1}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav> : null}
                </Col>
                    : <Row>
                        <Col xs={6}>
                            <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                                <Form.Group controlId="formCompanyName">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Email</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }} type="text"
                                        placeholder="Email"
                                        value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formCompanyDescription">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>First Name</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }} type="text"
                                        placeholder="First Name"
                                        value={formData.firstName} onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formCompanyCategory">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Last Name</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        type="text" placeholder="Last Name"
                                        value={formData.lastName} onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formCompany">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Department</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        as="select"
                                        value={formData.department}
                                        onChange={(e) => setFormData({ ...formData, department: e.target.value })}>
                                        <option value="">Select a department</option>
                                        {departments.map(department => (
                                            <option key={department._id} value={department._id}>{department.name}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Form>
                        </Col>
                        <Col xs={6}>
                            <Form style={{ fontFamily: "Noto Sans" }} className="w-100">
                                <Form.Group controlId="formCompanyEmployees">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Phone Number</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        type="text" placeholder="Phone Number"
                                        value={formData.phoneNumber} onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formCompanyCountry">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Country</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }} type="text"
                                        placeholder="Country"
                                        value={formData.country} onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formCompanyCity">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>City</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }} type="text"
                                        placeholder="City"
                                        value={formData.city} onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formCompany">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Designation</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        as="select"
                                        value={formData.designation}
                                        onChange={(e) => setFormData({ ...formData, designation: e.target.value })}>
                                        <option value="">Select a designation</option>
                                        {designations.map(designation => (
                                            <option key={designation._id} value={designation._id}>{designation.name}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group controlId="formCompany">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Role</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        as="select"
                                        value={formData.role}
                                        onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                                    >
                                        <option value="">Select a role</option>
                                        {roles.map(role => (
                                            <option key={role._id} value={role._id}>{role.name}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Form>
                        </Col>
                        <Col xs={12} style={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                            <Button onClick={isEdit ? handleModify : handleSubmit} style={{ fontWeight: '600', borderRadius: '20px', marginTop: '15px' }}
                                elevation={3}
                                className="w-25"
                                variant="primary" type="submit"
                                disabled={isLoading}>
                                {isLoading ? <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                /> : null}
                                {isEdit ? 'Edit' : 'Create'} Students
                            </Button>
                        </Col>
                    </Row>
                }
            </Row>
        </Container>
    </Grid >
}
export default EmployeeManage